import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Paper,
} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const PromptSelector = ({ prompts, selectedPrompt, onSelect, label, helperText }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        mb: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <AutoAwesomeIcon color="primary" fontSize="small" />
        <Typography variant="subtitle2" fontWeight={600}>
          Quick Selection
        </Typography>
      </Box>

      <FormControl fullWidth size="small">
        <InputLabel>{label}</InputLabel>
        <Select
          value={selectedPrompt}
          label={label}
          onChange={(e) => onSelect(e.target.value)}
        >
          <MenuItem value="">
            <em>Select a Prompt...</em>
          </MenuItem>
          {prompts.map((prompt) => (
            <MenuItem key={prompt.id} value={prompt.value}>
              {prompt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {helperText && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mt: 1 }}
        >
          {helperText}
        </Typography>
      )}
    </Paper>
  );
};

export default PromptSelector;
